import { makePropCacheMixin } from '../utils/cache';
export var attrsMixin = makePropCacheMixin('$attrs', 'bvAttrs');


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/mixins/attrs.js
// module id = 24
// module chunks = 0